<template>
  <div class="root">
    <div class="hh-donation-container hh-profile-container" ref="top"
    >
      <Alert
          v-if="notification.message"
          :message="notification.message"
          :type="notification.type"
          ref="alert"
      />

      <div class="row">
        <div class="col-md-4 col-xs-12 hh-campaign-sidebar">
          <div class="panel panel-default panel-small">
            <div class="container-fluid">
              <div class="row">
                <div class="col-xs-12">
                  <p class="margin-bottom-25 donation-overview"> DONATION OVERVIEW </p>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-8">
                  <p class="text-capitalize margin-0">
                    Your donation
                  </p>
                </div>
                <div class="col-xs-4">
                  <p class="text-capitalize margin-0">
                    ${{ donationData.amount }}
                  </p>
                </div>
              </div>
              <div class="row margin-top-10">
                <div class="col-xs-8">
                  <div class="processing-fees-wrapper">
                    <p class="text-capitalize processing-fees-label">
                      Processing fees
                    </p>
                    <checkbox class="text-capitalize"
                              v-model="donationData.add_processing_fees" @change="updateApplicationFee"/>
                  </div>
                </div>


                <div class="col-xs-4 lh-small">
                  <LoadingAnimation v-if="loadingApplicationFee" :width="20" :height="20"/>
                  <p class="text-capitalize margin-0" v-else>
                    ${{ donationData.processing_fees | floatValue }}
                  </p>
                </div>
              </div>
                <div class="row margin-top-10">
                <div class="col-xs-8">
                  <p class="text-capitalize margin-0">
                    Tip
                  </p>
                </div>
                <div class="col-xs-4">
                  <LoadingAnimation v-if="loadingApplicationFee" :width="20" :height="20"/>
                  <p class="text-capitalize margin-0" v-else>
                    ${{ donationData.tip | floatValue }}
                  </p>
                </div>
              </div>


              <hr>
              <div class="row margin-top-10">
                <div class="col-xs-8">
                  <p class="text-capitalize margin-0">
                    Total
                  </p>
                </div>
                <div class="col-xs-4 lh-small">
                  <LoadingAnimation v-if="loadingApplicationFee" :width="20" :height="20"/>
                  <p class="text-capitalize margin-0" v-else>
                    ${{ donationData.total | floatValue }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-xs-12">
          <div class="panel panel-default">

            <div class="container-fluid" v-if="isLoading">
              <div class="section-body margin-top-50">
                <LoadingAnimation :show-message="true"/>
              </div>
            </div>


            <div class="hh-campaign-main-container container-fluid" v-if="dataAnalysed" v-show="!isLoading">

              <div class="margin-bottom-30">
                <div class="row">
                  <div class="col-xs-12 campaign-img-wrapper">
                    <img alt="Campaign image" class="img campaign-card-img margin-right-20 margin-bottom-20"
                         :src="campaignData.primary_image_url"/>
                    <div>
                      <a class="text-left campaign-name margin-top-0" :href="campaignPath">
                        {{ campaignData.name }}
                      </a>
                      <p class="donation-organizer"> Organized by <span>{{ campaignData.contact_name }} </span></p>
                    </div>
                  </div>
                </div>
                <div class="website-donation-container margin-top-50" id="pricing">
                  <div class="row">
                    <div class="col-xs-12">
                      <p class="text-left account-title margin-bottom-20"> Select Your Donation </p>
                    </div>
                  </div>
                  <div class="row donation-amounts-wrapper">
                    <div class="col-md-3 col-xs-12">
                      <div class="donation-amount-item">
                        <button @click="selectPredefinedAmount('impact_item_1')" type="button"
                                class="width-100 btn hh-btn hh-btn-lg donation-amount-text" name="Donation amount 1"
                                :class="donationData.impact_item_selection === 'impact_item_1' ? 'selected' : ''"
                        >
                          <span>${{ campaignData.predefined_donations.impact_item_1.amount }}</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-3 col-xs-12">
                      <div class="donation-amount-item">
                        <button type="button" @click="selectPredefinedAmount('impact_item_2')"
                                class="width-100 btn hh-btn hh-btn-lg donation-amount-text" name="Donation amount 2"
                                :class="donationData.impact_item_selection === 'impact_item_2' ? 'selected' : ''"
                        >
                          <span>${{ campaignData.predefined_donations.impact_item_2.amount }}</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-3 col-xs-12">
                      <div class="donation-amount-item">
                        <button type="button" @click="selectPredefinedAmount('impact_item_3')"
                                class="width-100 btn hh-btn hh-btn-lg donation-amount-text" name="Donation amount 3"
                                :class="donationData.impact_item_selection === 'impact_item_3' ? 'selected' : ''"
                        >
                          <span>${{ campaignData.predefined_donations.impact_item_3.amount }}</span>
                        </button>
                      </div>
                    </div>
                    <div class="col-md-3 col-xs-12" @click="enableCustomAmount()">
                      <div class="donation-amount-item">
                        <button type="button" class="width-100 btn hh-btn donation-amount-text" name="Custom amount"
                                :class="donationData.custom_amount ? 'selected' : ''"
                        >
                          <span>Other</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div class="row margin-top-30 margin-bottom-30" v-if="donationData.custom_amount">
                    <div class="col-xs-12">
                      <label class="donation-select margin-left-0"> Enter custom donation </label>

                      <div class="custom-donation-wrapper">
                        <div class="dollar-sign">
                          $
                        </div>
                        <currency-input @input="updateApplicationFee" wrapper-class="width-100"
                                        :display-dollar-sign="false" v-model="donationData.amount"/>
                      </div>
                    </div>
                  </div>

                  <div class="row form">
                    <div class="col-xs-12">
                      <div class="invalid-feedback-red" v-if="applicationFeeErrors">
                        {{ applicationFeeErrors }}
                      </div>
                      <div class="invalid-feedback-red" v-if="form.errors.has('amount')">
                        {{ form.errors.get('amount') }}
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-xs-12">
                      <div class="margin-top-10 anonymous-donation-wrapper">
                        <input type="checkbox" id="anonymous_donation" class="anonymous-donation"
                               v-model="donationData.anonymous_donation"  label="Anonymous donation checkbox">
                        <label for="anonymous_donation" class="margin-left-10">
                          Make your donation anonymous
                        </label>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="tip-wrapper margin-top-50">
                  <p style="color:black;">Tip Help A Hero services</p>
                  <span>Help A Hero relies on the generosity of donors like you to operate our service.</span>
                  <div v-if="!showCustomTip" class="slider-container margin-top-20">
                    <div class="slider-labels">
                      <span>0%</span>
                      <span>30%</span>
                    </div>
                    <div class="tooltip" ref="tooltip" v-show="showTooltip">{{tipTooltipValue}}%</div>
                    <input type="range" min="0" max="30" step="5" :value="tipTooltipValue" class="slider" @input="updateTip"/>
                  </div>
                  <div v-if="!showCustomTip" class="margin-top-20">
                    <a @click="showCustomTipInput" style="text-decoration: underline; color: black; cursor:pointer;"> Enter custom tip </a> 
                  </div>
                  <div v-if="showCustomTip" class="row margin-top-30 margin-bottom-30">
                      <div class="col-xs-12" style="left: 0% !important;">
                        <label class="donation-select margin-left-0"> Enter custom tip amount </label>
                        <div class="custom-tip-wrapper">
                          <div class="dollar-sign">
                            $
                          </div>
                          <currency-input wrapper-class="width-100" :display-dollar-sign="false" v-model="donationData.tip"
                            @input="updateApplicationFee"
                          />
                        </div>
                        <a @click="showTipSlider" style="text-decoration: underline; color: black; float:right; cursor:pointer;" class="margin-top-10"> Back to default </a>
                      </div>
                  </div>
                </div>
              </div>

              <hr>
              <iframe name="formSubmitFrame" rel="nofollow" class="hidden"></iframe>
              <form
                action="https://helpahero.us20.list-manage.com/subscribe/post?u=28496bc2d2b229bbc1c44894b&amp;id=a66433d40d&amp;f_id=006e53e6f0"
                method="post" id="mc-embedded-subscribe-form-donor" name="mc-embedded-subscribe-form" class="validate"
                target="formSubmitFrame">
                <input type="hidden" :value="form.personalInformation.email" name="EMAIL" class="required email"
                  id="mce-EMAIL" required>
                <input type="hidden" :value="form.personalInformation.first_name" name="FNAME" class="" id="mce-FNAME">
                <input type="hidden" :value="form.personalInformation.last_name" name="LNAME" class="" id="mce-LNAME">
                <input type="hidden" :value="campaignData.name" name="CAMPAIGN" class="" id="mce-CAMPAIGN">
                <input type="hidden" :value="form.donationInformation.amount" name="AMOUNT" class="" id="mce-AMOUNT">
                <!-- 'donor' tag -->
                <div hidden="true"><input type="hidden" name="tags" value="1643298"></div>
                <div id="mce-responses" class="clear foot">
                  <div class="response" id="mce-error-response" style="display:none"></div>
                  <div class="response" id="mce-success-response" style="display:none"></div>
                </div>
                <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text"
                    name="b_28496bc2d2b229bbc1c44894b_a66433d40d" tabindex="-1" value=""></div>
              </form>
              <div class="form" ref="form">
                <div class="personal-information-wrapper" ref="personalInformation">
                  <div class="row margin-bottom-25">
                    <div class="col-sm-12">
                              <span class="text-left account-title">
                                Personal Information
                              </span>
                    </div>
                  </div>

                  <div class="row margin-bottom-10" v-if="!isAuthenticated">
                    <div class="form-group col-sm-12 cta-text" >
                      Are you a returning user? <a @click="openLoginModal" style="text-decoration: underline;"> Click here </a> to login for faster donation.
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-sm-12">
                      <input-label type="text" css-class="form-control" id="email"
                                   v-model="form.personalInformation.email"
                                   placeholder="Email address" required/>
                      <div>
                        <div class="invalid-feedback-red" v-if="form.errors.has('email')">
                          {{ form.errors.get('email') }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="form-group col-sm-6">
                      <input-label type="text" css-class="form-control" id="first_name"
                                   v-model="form.personalInformation.first_name"
                                   placeholder="First Name" required/>
                      <div>
                        <div class="invalid-feedback-red" v-if="form.errors.has('first_name')">
                          {{ form.errors.get('first_name') }}
                        </div>
                      </div>
                    </div>

                    <div class="form-group col-sm-6">
                      <input-label type="text" css-class="form-control" id="last_name"
                                   v-model="form.personalInformation.last_name"
                                   placeholder="Last Name" required/>
                      <div>
                        <div class="invalid-feedback-red" v-if="form.errors.has('last_name')">
                          {{ form.errors.get('last_name') }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12">
                      <div class="margin-top-10 anonymous-donation-wrapper">
                        <Checkbox v-model="subscribe" />
                        <label class="margin-left-10">
                          Subscribe to our newsletter
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form">
                  <div class="payment-wrapper" ref="paymentInformation">
                    <PaymentInformation ref="paymentInformationComponent"
                                        :user-data="form.paymentInformation"
                                        :stripe-key="stripeKey"
                                        :show-title="true"
                                        :show-save-card-checkbox="true"
                                        :errors="form.errors"
                                        :show-internal-error-message="true"
                                        :edit-mode="paymentInformationEditMode"
                                        @toggleEditMode="paymentInformationEditMode = !paymentInformationEditMode"
                                        @setPaymentFormState="setPaymentFormState"
                                        @componentLoading="componentLoading"
                    />
                  </div>
                </div>

                <div class="row margin-bottom-30" v-if="!isAuthenticated">
                  <div class="col-xs-12">
                    <div class="margin-top-10 create-account-wrapper">
                      <input type="checkbox" id="create_account" class="create-account-checkbox"
                             v-model="form.personalInformation.create_account" label="Create account">
                      <label for="create_account" class="margin-left-10">
                        Save information and create account
                      </label>
                    </div>
                  </div>
                </div>

                <div class="row margin-bottom-30" v-if="form.personalInformation.create_account">
                  <div class="form-group col-sm-12">
                    <password-container
                        v-model="form.personalInformation.password"
                        autocomplete="current-password"
                        placeholder="Enter password"
                        label="Password"
                        role="donor"
                        :required="true"
                        :showHint="true"
                        :withLabel="true"
                    />
                    <div>
                      <div class="invalid-feedback-red" v-if="form.errors.has('password')">
                        {{ form.errors.get('password') }}
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row margin-bottom-30 margin-top-30">
                  <div class="col-sm-12">
                    <div class="recaptcha-wrapper">
                      <vue-recaptcha ref="recaptcha"
                                      class="g-recaptcha"
                                     @verify="onCaptchaVerified"
                                     @expired="onCaptchaExpired"
                                     size="invisible"
                                     badge="inline"
                                     :sitekey="recaptchaSiteKey">
                      </vue-recaptcha>
                      <div class="invalid-feedback-red" v-if="form.errors.has('recaptcha_token')">
                        {{ form.errors.get('recaptcha_token') }}
                      </div>
                    </div>
                  </div>
                </div>


                <div class="row hh-form-btn-wrapper padding-bottom-20">
                  <div class="col-sm-5">
                    <div class="d-flex margin-bottom-20">
                      <LoadingAnimation v-if="loadingApplicationFee" :width="20" :height="20"/>
                      <p class="text-capitalize margin-0 text-right" v-else>
                        Total donation amount: ${{ donationData.total | floatValue }}
                      </p>
                    </div>
                    <button type="submit" :disabled="!formReady"
                            @click="submitForm"
                            class="btn hh-btn donate-btn hh-btn-green" name="Donate">
                      Donate
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <auth-modal
        ref="authModal"
        display-form="login"
        :can-switch-forms="false"
        :reload-on-complete="true"
        @complete="fetchAuthUser"
    />
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'

import PaymentInformation from '../../components/form/PaymentInformation'
import Address from '../../components/form/Address'
import Alert from '../../components/form/elements/Alert'
import Checkbox from '../../components/form/elements/Checkbox'
import InputLabel from '../../components/form/elements/InputLabel'
import CurrencyInput from '../../components/form/elements/CurrencyInput'
import PasswordContainer from '../../components/form/elements/PasswordContainer.vue'
import AuthModal from '../../components/auth/AuthModal.vue'
import LoadingAnimation from '../../components/LoadingAnimation'
import Form from '../../plugins/hh-form.js'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {scrollTo} from '../../utils/componentHelper'
import VueRecaptcha from 'vue-recaptcha'
import constants from "../../config.js"

export default {
  name: 'DonationView',

  components: {
    PaymentInformation,
    Address,
    Alert,
    Checkbox,
    LoadingAnimation,
    InputLabel,
    CurrencyInput,
    PasswordContainer,
    VueRecaptcha,
    AuthModal,
    'font-awesome-icon': FontAwesomeIcon,
    Checkbox
  },

  props: {},

  beforeMount() {
    this.campaignSlug = this.$route.params.slug
    this.recaptchaSiteKey = constants.RECAPTCHA_INVISIBLE_SITE_KEY
    if (this.$route.query.advocate) {
      this.donationData.advocate = this.$route.query.advocate
    }

    if (!this.isDataFetched) {
      this.fetchProfileData().then(() => {
        this.fetchCampaignDonationData(this.campaignSlug).then(() => {
          this.forceRecompute++
          this.analyseData()
        })
      })
    } else {
      this.analyseData()
    }
  },

  mounted() {
  },

  data() {
    return {
      campaignSlug: null,
      dataAnalysed: false,
      loading: true,
      loadingApplicationFee: true,
      paymentInformationEditMode: true,
      isPaymentFormReady: true,
      forceRecompute: 0,
      recaptchaSiteKey: null,
      subscribe: true,
      notification: {
        message: null,
        type: null,
      },
      componentsLoadingStatus: {
        PaymentInformation: true,
      },
      config: {},
      isAuthenticated: false,
      userData: {
        paymentInformation: {
          name: null,
          last4: null,
          brand: null,
        },
        contactInformation: {
          billing_first_name: null,
          billing_last_name: null,
          billing_address_1: null,
          billing_address_2: null,
          billing_country: 'United States',
          billing_city: null,
          billing_state: null,
          billing_zip: null,
        },
      },
      form: new Form({
        personalInformation: {
          email: null,
          first_name: null,
          last_name: null,
          create_account: false,
          password: null,
        },
        paymentInformation: {
          name: null,
          token: null,
          last4: null,
          brand: null,
          updateCardInformation: false,
          replaceCard: false,
          stripeErrors: null,
        },
        billingAddress: {
          billing_first_name: null,
          billing_last_name: null,
          billing_address_1: null,
          billing_address_2: null,
          billing_country: 'United States',
          billing_state: null,
          billing_city: null,
          billing_zip: null,
        },
        donationInformation: {
          amount: false,
          impact_item_selection: false,
          add_processing_fees: false,
          tip: false,
          anonymous_donation: false,
          recaptcha_token: null,
        },
        opType: 'update',
      }, this.$api),

      campaignData: {},
      donationData: {
        amount: 0.00,
        custom_amount: false,
        impact_item_selection: null,
        processing_fees: 0.00,
        total: 0.00,
        anonymous_donation: false,
        add_processing_fees: true,
        recaptcha_token: null,
        advocate: null,
        tip: 0.00,
      },
      applicationFeeErrors: null,
      staticData: Object,
      userRoles: Array,
      showTooltip: true,
      showCustomTip: false,
      tipTooltipValue: 5,
      defaultTipPercentage: 5,
    }
  },

  methods: {
    ...mapActions('profile', {'fetchProfileData': 'fetchData'}),
    ...mapActions('campaign', {'fetchCampaignDonationData': 'fetchDonationData'}),
    ...mapActions('checkout', ['checkout', 'calculateApplicationFee']),


    getTooltipPosition(x) {
      const values = [
        { x: 0,  y: 0},
        { x: 5, y: 18, },
        { x: 10, y: 34.5 },
        { x: 15, y: 50.5 },
        { x: 20, y: 66.5 },
        { x: 25, y: 82.5 },
        { x: 30, y: 100 }
      ];
      
      // Find the object in the array with the closest x value to the input x
      const closestValue = values.reduce(function(prev, curr) {
        return (Math.abs(curr.x - x) < Math.abs(prev.x - x) ? curr : prev);
      });
      
      // Return the y value of the closest x value
      return closestValue.y;
    },

  updateTip() {
    this.$nextTick(() => {
      const thumb = this.$el.querySelector('.slider');
      
      if (thumb) {
        this.showTooltip = true;
        this.tipTooltipValue = thumb.value;

        if(this.$refs.tooltip) {
          this.$refs.tooltip.style.left = `${this.getTooltipPosition(this.tipTooltipValue)}%`;
        }
      
        if(this.donationData.amount) {
          this.donationData.tip = this.tipTooltipValue /  100 * this.donationData.amount;
        }
        if(this.donationData.tip) {
          this.updateApplicationFee();
        }
       

        if (thumb.value === '0' || thumb.value === '30') {
          this.showTooltip = false;
        } else {
          this.showTooltip = true;
        }
      }
    });
  },

  showTipSlider() {
    this.showCustomTip = false;
    this.showTooltip = true;
    this.tipTooltipValue = this.defaultTipPercentage;
    if(this.donationData.amount) {
      this.donationData.tip = this.tipTooltipValue /  100 * this.donationData.amount;
      this.updateApplicationFee();
    }
  },

  showCustomTipInput() {
    this.showTooltip = false;
    this.donationData.tip = 5;
    this.updateApplicationFee();
    this.showCustomTip = true;
  },

    analyseData() {
      if (!_.isEmpty(this.profileData)) {
        this.fillUserData()
      } else {
        this.isAuthenticated = false
      }

      if (!_.isEmpty(this.fetchedCampaignData)) {
        this.fillCampaignData()
        this.fillDonationData()
        this.fillConfigData()
      } else {
        this.$router.push('404')
      }

      this.dataAnalysed = true
      this.loading = false
      this.loadingApplicationFee = false
      scrollTo(this.$refs['top'])
    },

    fillUserData() {
      this.isAuthenticated = true
      this.userRoles = this.profileData.data.attributes.roles

      this.fillPersonalInformation()
      this.fillPaymentInformation()
      this.fillContactInformation()
      this.fillStaticData()
    },

    fillCampaignData() {
      this.campaignData = {...this.campaignData, ...this.fetchedCampaignData.data.attributes}
    },

    fillDonationData() {
      if (!_.isEmpty(this.fetchedCampaignData.data.relations.donationData)) {
        this.donationData = {...this.donationData, ...this.fetchedCampaignData.data.relations.donationData}
        this.donationData.amount = parseFloat(this.donationData.amount)
        this.donationData.processing_fees = parseFloat(this.donationData.processing_fees)
        this.donationData.total = parseFloat(this.donationData.total)
        this.donationData.add_processing_fees = this.donationData.total !== this.donationData.amount

        if (this.donationData.impact_item_selection == null) {
          setTimeout(() => {
            this.donationData.custom_amount = true
            this.loadingApplicationFee = false
          }, 1000);
        }

        if (!this.isAuthenticated) {
          this.form.personalInformation.first_name = this.donationData.first_name
          this.form.personalInformation.last_name = this.donationData.last_name
          this.form.personalInformation.email = this.donationData.email
          this.form.personalInformation.create_account = false
        }
      }
    },

    fillPersonalInformation() {
      this.form.personalInformation.first_name = this.profileData.data.attributes.first_name
      this.form.personalInformation.last_name = this.profileData.data.attributes.last_name
      this.form.personalInformation.email = this.profileData.data.attributes.email
      this.form.personalInformation.create_account = false
    },

    fillPaymentInformation() {
      if (!_.isEmpty(this.profileData.data.relations.paymentInformation)) {
        let paymentInformation = this.profileData.data.relations.paymentInformation[0].data.attributes

        this.userData.paymentInformation = {...paymentInformation}
        // this.userData.paymentInformation.name = this.profileData.data.attributes.name
      }

      if (!_.isEmpty(this.userData.paymentInformation.last4)) {
        this.paymentInformationEditMode = false
      }

      this.form.paymentInformation = {...this.form.paymentInformation, ...this.userData.paymentInformation}
    },

    fillContactInformation() {
      if (!_.isEmpty(this.profileData.data.relations.contact)) {
        let contactData = this.profileData.data.relations.contact.data.attributes

        this.userData.contactInformation = {...contactData}
      }
    },

    fillStaticData() {
      if (!_.isEmpty(this.profileData.data.staticData)) {
        this.staticData = this.profileData.data.staticData
      }
    },

    fillConfigData() {
      if (!_.isEmpty(this.fetchedCampaignData.config)) {
        this.config = this.fetchedCampaignData.config
      }
    },

    fetchAuthUser() {
      // this.loading = true
      //
      // this.fetchProfileData().then(() => {
      //   this.forceRecompute++
      //   this.fillUserData()
      //   this.loading = false
      // })
    },

    componentLoading(componentName, value) {
      this.componentsLoadingStatus[componentName] = value
    },

    async submitForm() {
      this.loading = true
      this.customError = null
      this.$refs.paymentInformationComponent.$data.customError = null

      if (_.isEmpty(this.form.paymentInformation.last4) && !this.$refs.paymentInformationComponent.canSubmit()) {
        scrollTo(this.$refs['form'])
        this.loading = false
        return false
      }

      if (this.$refs.paymentInformationComponent.shouldSubmit()) {
        if (!this.isAuthenticated) {
          this.form.paymentInformation.replaceCard = true
        }

        await this.$refs.paymentInformationComponent.submitForm()
        if (!this.checkPaymentInformation()) {
          this.loading = false
          return false
        }
      }

      return this.onCaptchaExecute()
    },

    async sendFormData() {
      this.loading = true;
      this.form.campaignSlug = this.campaignSlug
      this.form.donationInformation = {
        amount: this.donationData.amount,
        tip: this.donationData.tip,
        impact_item_selection: this.donationData.impact_item_selection,
        add_processing_fees: this.donationData.add_processing_fees,
        anonymous_donation: this.donationData.anonymous_donation,
        recaptcha_token: this.donationData.recaptcha_token,
        advocate: this.donationData.advocate,
      }
      this.fillAddressData(this.mappedBillingAddressData, 'billing')
      this.$refs.recaptcha.reset()

      await this.checkout(this.form)

      if (this.form.errors.any()) {
        this.loading = false
        this.forceRecompute++
        this.onCaptchaExpired()
        if (this.form.errors.has('stripeErrors')) {
          scrollTo(this.$refs['form'])
        }
        this.fetchProfileData().then(() => {
          this.forceRecompute++
          this.dataAnalysed = false
          this.loading = true
          this.analyseData()
        })
        return false
      }

      let userInformation = {}
      userInformation.name = `${this.form.personalInformation.first_name} ${this.form.personalInformation.last_name}`
      userInformation.email = `${this.form.personalInformation.email}`

      this.$refs.paymentInformationComponent.confirmCardPayment(this.form.billingAddress, this.form.response.data, userInformation).then(() => {
        if (!this.checkPaymentInformation()) {
          if (!this.isAuthenticated && this.form.personalInformation.create_account) {
            this.fetchProfileData().then(() => {
              this.forceRecompute++
              this.dataAnalysed = false
              this.loading = true
              this.analyseData()
            })
          } else {
            this.loading = false
          }
          return false
        }
        if (this.subscribe) {
          document.getElementById("mc-embedded-subscribe-form-donor").requestSubmit();
        }
        window.location = `/campaign/${this.campaignSlug}/donate/success`
        return true
      })
    },

    checkPaymentInformation() {
      if (!_.isEmpty(this.$refs.paymentInformationComponent.$data.customError)) {
        this.customError = this.$refs.paymentInformationComponent.$data.customError
        return false
      }

      if (!_.isEmpty(this.$refs.paymentInformationComponent.$data.stripeError)) {
        this.customError = this.$refs.paymentInformationComponent.$data.stripeError
        return false
      }

      return true
    },

    mapAddressData(data, prefix) {
      return {
        'firstName': data[`${prefix}_first_name`],
        'lastName': data[`${prefix}_last_name`],
        'address1': data[`${prefix}_address_1`],
        'address2': data[`${prefix}_address_2`],
        'country': data[`${prefix}_country`],
        'city': data[`${prefix}_city`],
        'state': data[`${prefix}_state`],
        'zip': data[`${prefix}_zip`],
      }
    },

    fillAddressData(data, type) {
      this.form[`${type}Address`][`${type}_first_name`] = data.firstName
      this.form[`${type}Address`][`${type}_last_name`] = data.lastName
      this.form[`${type}Address`][`${type}_address_1`] = data.address1
      this.form[`${type}Address`][`${type}_address_2`] = data.address2
      this.form[`${type}Address`][`${type}_country`] = data.country
      this.form[`${type}Address`][`${type}_city`] = data.city
      this.form[`${type}Address`][`${type}_state`] = data.state
      this.form[`${type}Address`][`${type}_zip`] = data.zip
    },

    onCaptchaVerified: async function (recaptchaToken) {
      this.donationData.recaptcha_token = recaptchaToken
      await this.sendFormData()
    },
    onCaptchaExpired: function () {
      this.$refs.recaptcha.reset()
    },
    onCaptchaExecute() {
      this.$refs.recaptcha.execute()
    },

    setPaymentFormState(value) {
      this.isPaymentFormReady = value
    },

    selectPredefinedAmount(impact_item_selection) {
      this.donationData.custom_amount = false
      this.donationData.add_processing_fees = true;
      this.donationData.impact_item_selection = impact_item_selection
      this.donationData.amount = this.campaignData.predefined_donations[impact_item_selection].amount
      this.donationData.processing_fees = this.campaignData.predefined_donations[impact_item_selection].processing_fee
      if(!this.showCustomTip) {
        this.donationData.tip = this.donationData.amount * this.tipTooltipValue / 100;
      }
      this.donationData.total = this.campaignData.predefined_donations[impact_item_selection].total + this.donationData.tip
      this.loadingApplicationFee = false
    
    },

    enableCustomAmount() {
      this.donationData.impact_item_selection = null
      this.donationData.amount = 0.00
      this.donationData.processing_fees = 0.00
      this.donationData.total = 0.00
      this.donationData.tip = 0.00
      this.donationData.custom_amount = true
    },

    async updateApplicationFee() {
      this.loadingApplicationFee = true;
      if (this.donationData.amount !== 0) {
        let form = new Form(this.donationData, this.$api)
        await this.calculateApplicationFee(form)

        if (form.errors.any()) {
          this.applicationFeeErrors = form.errors.get('amount')
          return false
        }

        this.donationData.processing_fees = form.response.data.processing_fees
        if (this.donationData.add_processing_fees) {
          this.donationData.total = form.response.data.total
        } else {
          this.donationData.total = form.response.data.amount
        }

        if(!this.showCustomTip && this.donationData.amount) {
          this.donationData.tip = this.donationData.amount * this.tipTooltipValue / 100;
        }

        this.donationData.total = this.donationData.total + this.donationData.tip;
        setTimeout(100);
      }
      this.loadingApplicationFee = false
    },

    openLoginModal() {
      this.$refs.authModal.openModal()
    }
  },

  computed: {
    ...mapGetters('profile', ['profileData']),
    ...mapGetters(['alert']),

    fetchedCampaignData: {
      get() {
        return this.$store.getters['campaign/campaignDonationData'](this.campaignSlug, this.forceRecompute)
      },
    },

    isDataFetched() {
      return !_.isEmpty(this.profileData) && !_.isEmpty(this.fetchedCampaignData)
    },

    campaignPath() {
      return `/campaign/${this.campaignSlug}`
    },

    campaignLogoUrl() {
      const defaultImageUrl = '/dist/site/static/icons/default-avatar.svg'

      return !_.isEmpty(this.campaignData.logo_url) ? this.campaignData.logo_url : defaultImageUrl
    },

    isLoading() {
      for (let component in this.componentsLoadingStatus) {
        if (this.componentsLoadingStatus[component]) {
          return true
        }
      }

      return this.loading
    },

    role() {
      if (!_.isEmpty(this.userRoles) && this.userRoles.includes('organizer')) {
        return 'organizer'
      }

      return 'donor'
    },

    stripeKey() {
      if (_.isEmpty(this.config.stripe_key)) {
        return null
      }

      return this.config.stripe_key
    },

    mappedBillingAddressData() {
      return this.mapAddressData(this.userData.contactInformation, 'billing')
    },

    formReady() {
      return this.isPaymentFormReady && !this.loading
    },
  },

  filters: {
    floatValue: function (value) {
      if (value == null) return ''
      return `${parseFloat(value).toFixed(2)}`
    }
  }
}
</script>

<style lang="scss" scoped>
.root::v-deep {
  @import '../../../style/pages/donation';
}
</style>